export enum EventParticipantStatusEnum {
  PAYMENT_REQUIRED = 'PAYMENT_REQUIRED',
  REGISTERED = 'REGISTERED',
  WAIT_VALIDATE = 'WAIT_VALIDATE',
  WAIT_VALID = 'WAIT_VALID',
  REJECTED = 'REJECTED',
}
